import React from 'react';
import MainLayout from '../../layouts/MainLayout';
import { Card } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';
import InvoiceEstimateTab from '../../components/finance/InvoiceEstimateTab';

const Estimates = () => {
  return (
    <MainLayout>
      <div style={{ fontFamily: 'CustomFont' }}>
        <Card className="shadow-xl border-0" bodyStyle={{ padding: 0 }}>
          <div className="flex items-center justify-between flex-wrap gap-4 p-6 border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 rounded-t-xl">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-blue-50 dark:bg-blue-900/20 flex items-center justify-center">
                <FileTextOutlined className="text-blue-600 dark:text-blue-400 text-xl" />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100 m-0">پیش‌فاکتورها</h1>
                <p className="text-gray-500 dark:text-gray-400 text-sm m-0">مدیریت و پیگیری پیش‌فاکتورها</p>
              </div>
            </div>
          </div>
          <div className="p-6 bg-gray-50 dark:bg-gray-900/50 rounded-b-xl">
            <InvoiceEstimateTab />
          </div>
        </Card>
      </div>
    </MainLayout>
  );
};

export default Estimates;
